'use strict';

function GridColumnAvailabilityMatchingService() {
  function isGridModeMatching(expectedGridMode, currentGridMode) {
    return expectedGridMode === currentGridMode;
  }
  return {
    isGridModeMatching: isGridModeMatching
  };
}
module.exports = GridColumnAvailabilityMatchingService;